import { createCrudActions } from '../utils/crudGenerator';

const formatRoles = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchRoles,
    create: createRole,
    update: updateRole,
    delete: deleteRoles
} = createCrudActions('ROLE', "Role", formatRoles);